import { RefObject, useEffect, useState } from 'react';

export const useIsInViewport = (ref: RefObject<HTMLDivElement | null>) => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const observer = (() => new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting)))();
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return isIntersecting;
};
